// extracted by mini-css-extract-plugin
export default {"authorList":"AuthorsList_authorList__194tC"};